<template>
  <!--#index，profile，tag都需要显示所有的blog-->
  <!--<h1 class="blog-name"><a href="changxin10m.com">知行合一</a></h1>-->
  <!--<span class="blog-description">求知笃行，珍惜所爱</span>-->
  <div>
    <header id="blog-header">
      <div class="inner ">
        <slot name="headContent"></slot>
        <search-bar
          v-model="searchKeyword"
          @search="handleSearch"
          :suggestions="suggestions"
        ></search-bar>
      </div>
    </header>
    <!--<slot name="authorInfo"></slot>-->
    <all-blogposts :func="func"></all-blogposts>
  </div>
</template>

<script>
import allBlogposts from './AllBlogPosts'
import SearchBar from '../components/SearchBar'
import { fetchSearchSuggestions } from '../utils/search'
export default {
  name: 'index',
  components: {
    allBlogposts,
    SearchBar
  },
  data: function(){
    return {
      func: 'index',
      searchKeyword: '',
      suggestions: []
    }
  },
  created () {
    this.loadSuggestions()
  },
  mounted () {
  },
  updated() {
  },
  methods: {
    async loadSuggestions () {
      this.suggestions = await fetchSearchSuggestions(this.$http, this.$store.state.baseUrl)
    },
    handleSearch (query) {
      const trimmed = (query || '').trim()
      this.searchKeyword = trimmed
      if (!trimmed) {
        this.$router.push({ name: 'search' })
        return
      }
      this.$router.push({
        name: 'search',
        query: {
          q: trimmed,
          page: 1
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
